import { useStore } from 'dg-web-shared/lib/Flux';
import { ResponsiveProperties } from '../utils/ResponsiveProperties';
import { LogoSloganVariant } from '../utils/LogoSloganVariant';
import { ThreeColumnsProperties } from '../utils/ThreeColumnsProperties';
import { responsiveVariant } from '../utils/responsiveVariant';
import * as LayoutState from '../state/LayoutState';
import { css } from '@emotion/css';
import { Colors } from 'dg-web-shared/ui/vars';
import { LayoutVariantOption } from './LayoutContainer';

export function LayoutBackground({
    layoutVariant,
}: {
    layoutVariant: LayoutVariantOption;
}) {
    const { storeState } = useStore(store => ({
        layout: new LayoutState.StateSlice(store).state,
    }));

    const responsiveProperties = new ResponsiveProperties(storeState);
    const columnProperties = new ThreeColumnsProperties(storeState);
    const logoSloganVariant = new LogoSloganVariant(storeState, layoutVariant);

    if (responsiveProperties.mobile) {
        return null;
    }

    return (
        <div
            className={css([
                {
                    backgroundColor: Colors.background,
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    margin: '0 80px 0 80px',
                },
                columnProperties.variant.toString() === 'ThreeColumns' && [
                    {
                        top: '168px',
                    },
                    layoutVariant === LayoutVariantOption.Application && [
                        responsiveVariant(storeState) === 'DesktopLarge' && {
                            top: '136px',
                        },
                        responsiveVariant(storeState) === 'Desktop' && {
                            top: '112px',
                        },
                    ],
                ],
                columnProperties.variant.toString() === 'OneColumn' && {
                    margin: 0,
                    top: '112px',
                },
            ])}
            data-layout-variant={layoutVariant.toString()}
            data-columns-variant={columnProperties.variant.toString()}
            data-logoslogan-variant={logoSloganVariant.toString()}
            data-responsive-variant={responsiveVariant(storeState)}
        />
    );
}
